// app/composables/routeQuery.ts
//
// MEMORY LEAK FIX (2025-12-31):
// - Moved global functions inside the composable
// - useRoute() and useRouter() now called once at setup level
// - This prevents EffectScope retention during SSR

import type { LocationQuery } from "vue-router";

type Query = Record<string, string | number>;

type HandleQueriesOpts = {
  replace: boolean;
};

const defaultOpts: HandleQueriesOpts = {
  replace: false,
};

interface UseRouteQuery {
  addQuery: (query: Query, handleQueriesOpts?: HandleQueriesOpts) => void;
  deleteQuery: (query: string | string[], handleQueriesOpts?: HandleQueriesOpts) => void;
  getRouteQueryParam: (name: string) => string | undefined;
}

export function useRouteQuery(): UseRouteQuery {
  // MEMORY LEAK FIX: Get composables at setup level
  const route = useRoute();
  const router = useRouter();

  // MEMORY LEAK FIX: Functions now use route/router from setup scope
  function addQuery(newQuery: Query, handleQueriesOpts?: HandleQueriesOpts) {
    try {
      if (route.query) {
        const options = handleQueriesOpts ? { ...defaultOpts, ...handleQueriesOpts } : defaultOpts;
        const currentQuery = JSON.parse(JSON.stringify(route.query));
        const _query = { ...currentQuery, ...newQuery };
        Object.keys(_query)
          .sort()
          .forEach(key => {
            const aux = _query[key];
            delete _query[key];
            _query[key] = aux;
          });

        if (_query) {
          options.replace ? router.replace({ query: _query }) : router.push({ query: _query });
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  function deleteQuery(queryName: string | string[], handleQueriesOpts?: HandleQueriesOpts) {
    if (route.query) {
      try {
        const options = handleQueriesOpts ? { ...defaultOpts, ...handleQueriesOpts } : defaultOpts;
        const _query: LocationQuery = JSON.parse(JSON.stringify(route.query));

        if (typeof queryName === "string") {
          delete _query[queryName];
        } else {
          queryName.forEach(q => {
            delete _query[q];
          });
        }

        if (_query) {
          options.replace ? router.replace({ query: _query }) : router.push({ query: _query });
        }
      } catch (e) {
        console.error(e);
      }
    }
  }

  function getRouteQueryParam(name: string): string | undefined {
    const param = route.query[name];
    return typeof param === "string" ? param : undefined;
  }

  return {
    addQuery,
    deleteQuery,
    getRouteQueryParam,
  };
}
